import { addDataLayerEntry } from '@printdeal/data-layer-manager';

const dispatchDataLayerEventOnMultiVariantProductListGA4 = (
  eventName: string,
  position: number,
  expVariant: string | undefined,
  audienceType: string | null | undefined,
  productName: string,
) => {
  const contentType = expVariant === 'variant' ? 'personalized' : 'non-personalized';
  const audience = audienceType === 'no_audience' ? 'non-recognized' : audienceType;
  addDataLayerEntry(
    eventName,
    {
      position,
      content_type: contentType,
      audience_type: audience,
      productName,
    },
  );
};

export const handleMultiVariantProductListClick = (
  position: number,
  variation: string | undefined,
  audienceType: string | null | undefined,
  productName: string,
) => {
  dispatchDataLayerEventOnMultiVariantProductListGA4('homepage_featuredproducts', position, variation, audienceType, productName);
};

export const handleCategoryRecommendationsForYouClick = (
  position: number,
  variation: string | undefined,
  audienceType: string | null | undefined,
  productName: string,
) => {
  dispatchDataLayerEventOnMultiVariantProductListGA4('homepage_category_recommendations', position, variation, audienceType, productName);
};
